var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline is-marginless has-padding-50 has-padding-bottom-400"},[_c('div',{staticClass:"column is-12"},[_c('collapse',{attrs:{"title":"Invoice"}},[_c('invoice',{attrs:{"invoice-id":_vm.invoiceId}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }